import renderInlineItalic from 'lib/utils/renderInlineItalic';
import classNames from 'classnames';
import Image from 'components/shared/image';
import VideoPlayer from 'components/shared/video/video';
import Button from 'components/shared/button';
import RichText from 'components/shared/richtext';
import styles from './spotlight.module.scss';

const Spotlight = ({ data, locale }) => {
  const {
    media,
    title,
    titleFont,
    body,
    button,
    textColor,
    textColorMobile,
    hasOverlay,
    overlayOpacity,
    contentAlignmentVerticalDesktop,
    contentAlignmentVerticalMobile,
    anchorId,
  } = data || {};
  const titleClass = classNames(styles.title, titleFont !== 'Acumin Pro' && styles.octave);
  const mediaLink = media?.image?.link || media?.video?.link || false;

  const justifyValues = {
    top: 'flex-start',
    center: 'center',
    bottom: 'flex-end',
  };

  const verticalAlignmentDesktop =
    justifyValues[contentAlignmentVerticalDesktop?.toLowerCase()] || 'flex-end';
  const verticalAlignmentMobile =
    justifyValues[contentAlignmentVerticalMobile?.toLowerCase()] || 'flex-end';

  return (
    <section id={anchorId} className={styles.wrapper}>
      {media?.type === 'Video' && media?.video ? (
        <VideoPlayer
          className={classNames(styles.media)}
          thumbnail={media?.thumbnail}
          source={media.video}
          sourceDesktop={media.videoDesktop}
          autoPlay
          controls={false}
          forceKeepPlaying
        />
      ) : (
        <Image
          src={media.image}
          layout="fill"
          className={classNames(styles.media, {
            [styles.focusOutline]: mediaLink,
          })}
          loading="eager"
          priority
        />
      )}

      <div
        className={classNames(styles.content, {
          [styles.hasOverlay]: hasOverlay,
          [styles.pointerNone]: mediaLink,
        })}
        style={{
          '--text-color': textColor === 'White' ? '#FFFFFF' : '#000000',
          '--text-color-mobile': textColorMobile === 'White' ? '#FFFFFF' : '#000000',
          '--overlay-opacity': overlayOpacity || overlayOpacity === 0 ? overlayOpacity / 100 : 100,
          '--content-alignment-vertical-desktop': verticalAlignmentDesktop,
          '--content-alignment-vertical-mobile': verticalAlignmentMobile,
        }}
      >
        {title && <span className={titleClass}>{renderInlineItalic(title)}</span>}
        {body?.json ? <RichText className={styles.body} text={body.json} /> : null}
        {button && <Button locale={locale} button={button} className={styles.button} />}
      </div>
    </section>
  );
};

export default Spotlight;
